const e=e=>r=>{let t=e;return Object.entries(r).forEach((([e,r])=>t=t.replace(`{{${e}}}`,r))),t};function r(r,t){return t?e(r)(t):e(r)}export{r as formatString};
//# sourceMappingURL=formatString.js.map
